document.addEventListener('DOMContentLoaded', function() {
  const loadMoreBtn = document.getElementById('loadMoreBtn');
  const contentContainer = document.getElementById('contentContainer');
  const fadeOverlay = document.getElementById('fadeOverlay');
  const additionalContent = document.getElementById('additionalContent');

  if (loadMoreBtn && contentContainer && fadeOverlay) {
    loadMoreBtn.addEventListener('click', function() {
      // 1. Expand the initial content
      contentContainer.classList.add('load-more');
      
      // 2. Hide the fade overlay
      fadeOverlay.classList.add('hidden');
      
      // 3. Show the new content below the button
      additionalContent.style.display = 'block';
      
      // 4. Hide or keep the button (choose one)
      // loadMoreBtn.style.display = 'none'; // To hide
      loadMoreBtn.textContent = 'Content Loaded'; // To keep visible
    });
  }
});